// src/utils/timeUtils.js

// 格式化：年-月-日 时:分
export const formatDateTime = (timestamp) => {

  if (!timestamp) return '';

  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

// formatHourMinute 时:分
export const formatHourMinute = (timestamp) => {

  if (!timestamp) return '';

  const date = new Date(timestamp);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

// 格式化时间 (秒 -> mm:ss)
export const formatTime = (seconds) => {
  if (isNaN(seconds)) return '00:00';
  
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// 解析时间 (mm:ss -> 秒)
export const parseTime = (timeString) => {
  const parts = timeString.split(':');
  
  if (parts.length === 2) {
    const minutes = parseInt(parts[0], 10);
    const seconds = parseInt(parts[1], 10);
    
    if (!isNaN(minutes) && !isNaN(seconds)) {
      return minutes * 60 + seconds;
    }
  }
  
  return 0;
};

// 计算时间偏移
export const calculateOffset = (baseTime, offset) => {
  return Math.max(0, baseTime - offset);
};

export default {
  formatTime,
  parseTime,
  calculateOffset
};